import angular from 'angular';
import uiRouter from 'angular-ui-router';
import loginComponent from './login.component';
import apiSuppliersService from '../../../api/suppliers.service';
import sharedService from '../../../services/shared.service';
import cacheService from '../../../services/cache.service';

const loginModule = angular.module('login', [
        uiRouter,
        apiSuppliersService,
        sharedService,
        cacheService
    ])
    .config(($stateProvider) => {
        "ngInject";
        $stateProvider
            .state('auth.login', {
                url: '/login',
                template: '<login></login>'
            });
    })
    .component('login', loginComponent)
    .name;

export default loginModule;



// WEBPACK FOOTER //
// ./client/app/components/auth/login/login.js